import PocketTrackPJ from "../../assets/Project/Expense-Track_pj.png";
import mcp from "../../assets/Project/mcp.png";
import postify from "../../assets/Project/postify.png";
import mailcraft from "../../assets/Project/mailcraft.png";

const projectsData = [
  {
    id: 4,
    image: postify,
    title: "Postify – AI Cover Letter SaaS",
    category: "web",
    description:
      "Full-stack SaaS platform for AI-powered cover letter generation using Next.js, Express.js, and PostgreSQL. Designed with clean architecture principles (Dependency Injection, Repository Pattern) to ensure scalability and maintainability. Implemented secure OAuth 2.0 authentication with Gmail API integration, enabling passwordless login and direct email sending. Built a flexible AI abstraction layer supporting multiple providers for multilingual content generation. Developed a robust backend with rate limiting, schema validation (Zod), pagination, and Prisma ORM for efficient data management and performance.",
    technologies: [
      "Next.js",
      "Node.js",
      "Express",
      "PostgreSQL",
      "Prisma",
      "OAuth 2.0",
      "JWT",
      "Zod",
      "Tailwind CSS",
      "OpenAI API",
      "Gmail API",
    ],
    demo: "https://posttify.vercel.app/",
    repo: "https://github.com/moteaz/Postify",
  },
  {
    id: 3,
    image: mailcraft,
    title: "MailCraft – Email Automation & Template Platform",
    category: "web",
    description:
      "Developed a scalable email automation platform during a professional internship, enabling teams to design, manage, and send dynamic, event-driven emails. Built using NestJS and React with a strong focus on backend architecture and API design. Implemented secure authentication (JWT, RBAC, refresh tokens) and advanced features such as real-time updates (SSE), webhooks, and PDF export. Designed efficient database schemas using Prisma and SQLite, ensuring optimized data handling and system performance. Integrated Nodemailer for reliable and automated email delivery workflows.",
    technologies: [
      "React",
      "Node.js",
      "NestJS",
      "Prisma",
      "SQLite",
      "JWT",
      "RBAC",
      "SSE",
      "Webhooks",
      "Nodemailer",
      "Tailwind CSS",
    ],
    repo: "https://github.com/moteaz/mailCraftr",
  },
  {
    id: 2,
    image: mcp,
    title:
      " AI-Integrated Model Context Protocol (MCP) Server for GLPI and System Access",
    category: "backend",
    description:
      "I built an MCP server helpdesk equipped with tools for GLPI, designed to be used by an AI agent to create, update, and manage tickets efficiently. The server can interact with other systems, enabling seamless integration beyond GLPI. By combining automation, AI-driven decision making, and robust ticket management, this AI-powered helpdesk enhances IT workflows, reduces manual effort, and provides intelligent support across multiple platforms.",
    technologies: ["Python", "FastAPI", "MCP", "GLPI", "Doker", "Ollama"],
  },
  {
    id: 1,
    image: PocketTrackPJ,
    title: "Pocket Track Application",
    category: "web",
    description:
      "PocketTrack is a modern web app designed to simplify personal finance. Built with React, Node.js, and powered by LLaMA AI, it allows users to securely log in and manage their income and expenses with ease. Users can add, view, and delete transactions, which are visually represented through clear and dynamic charts. A built-in AI chatbot provides smart insights and spending analysis, helping users stay on top of their finances and make better money decisions.",
    technologies: [
      "React",
      "Node.js",
      "Express",
      "RESTful API",
      "JWT",
      "Tailwind CSS",
      "PostgreSQL",
      "Excel",
      "ollama",
    ],
    repo: "https://github.com/moteaz/PocketTrack-Application",
  },
];

export default projectsData;